import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { environment } from 'environments/environment';
import { BaseFormService } from 'app/services/BaseFormService';
import { FileUploadService } from '../file-upload-service';

@Injectable({
	providedIn: 'root',
})
export class AccessChangeFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService, private fileUpload: FileUploadService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/access-change`, httpClient, utilityService);
		this.setFileUploadService(fileUpload);
	}

	// Override to handle form without attachments
	createFormWithDocuments(clientId: string, request: any): Observable<any> {
		const formData = new FormData();
		formData.append('model', JSON.stringify(request));
		return this.httpClient.post<any>(`${this.getUrl(clientId)}`, formData).pipe();
	}

	// Override to handle form without attachments
	updateFormWithDocuments(clientId: string, formId: any, request: any): Observable<any> {
		const formData = new FormData();
		formData.append('model', JSON.stringify(request));
		return this.httpClient.put<any>(`${this.getUrl(clientId)}/${formId}`, formData).pipe();
	}
}
